<template>
    <div class="wizard-radio-tag radio-tags--tags-item">
        <label class="radio-tags--tag-label" :for="tagId">
            <input class="radio-tags--input"
                    :name="name"
                    type="radio"
                    :value="value"
                    :checked="initialValue === value"
                    :id="tagId"
                    @change="onUpdate({ id: tagId, value })">
            <span class="radio-tags--tags-tag-text">
                <slot name="value_1"/>
            </span>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            tagId: {
                type: String,
                required: true,
            },
            initialValue: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
        },
    };
</script>
